import Container from "components/core/Layout/Container/Container";

interface Props {
  children: React.ReactNode;
}

const MobileLayout = (props: Props) => {
  return <Container>{props.children}</Container>;
};

export default MobileLayout;
